const testimonials = [
  {
    name: "Michael R.",
    location: "Bloomington, MN",
    rating: 5,
    text: "I had a business trip to London in ten days and discovered my passport expired during COVID. Fast Passport Center processed my renewal in five business days. I made my flight out of MSP without a single issue. Professional, fast, and their document review caught a photo issue I would have missed.",
    service: "Passport Renewal",
  },
  {
    name: "Sarah & David K.",
    location: "Near Mall of America, Bloomington",
    rating: 5,
    text: "We booked a Caribbean cruise for our anniversary and realized the week before that my passport was expired. Panic mode. Called Fast Passport Center on Monday, shipped documents overnight from Bloomington, and had my new passport Thursday. We sailed Saturday morning. No idea what we would have done without them.",
    service: "Emergency Renewal",
  },
  {
    name: "Jessica T.",
    location: "Normandale Area, Bloomington",
    rating: 5,
    text: "My daughter was accepted to a summer study program in Spain and needed her first passport. We had no idea where to start. Fast Passport Center walked us through the acceptance clerk process at the Bloomington post office, reviewed every document, and got her passport in seven business days. She made her program orientation with time to spare.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BloomingtonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Bloomington &amp; South Metro Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Bloomington, Mall of America area, and Hennepin County travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}